import store from 'state/RootReducer';

import { TemplateService } from 'services';
import { BaseAppActions } from 'state/baseapplication/Action';
import { ManagePacketEnd, RestEnds } from 'shared/Constants';
import { APIManager, axios } from 'shared/manager';
import { CancelStatic } from 'shared/manager/AxiosManager';

/**
 * Sends a request to retrieve packets data using method GET /getPackets.
 * @param {any} data - The request data.
 * @returns {Promise<any>} The promise that resolves with the response data.
 */
const getPackets = async (data: any): Promise<any> =>
    APIManager.sendGetWithBody(ManagePacketEnd.GET_PACKETS, data, true, axios);

/**
 * Sends a request to retrieve report Vertices data using method GET /reportVertices.
 * @param {any} data - The request data.
 * @returns {Promise<any>} The promise that resolves with the response data.
 */
const getReportVertices = async (data: any): Promise<any> =>
    APIManager.sendGetWithBody(
        ManagePacketEnd.GET_REPORT_VERTICES,
        data,
        true,
        axios
    );

/**
 * Send a request to update review packet data using method POST /reviewPacket.
 * @param {GetReviewRequest} data - The request data.
 * @returns {Promise<any>} The promise that resolves with the response data.
 */
const reviewReport = async (data: ReviewReportRequest): Promise<any> =>
    APIManager.sendPost(
        ManagePacketEnd.REVIEW_REPORT,
        data,
        true,
        {},
        {},
        axios
    );

/**
 * Sends a request to retrieve packets data using method GET /getPackets.
 * @param {any} data - The request data.
 * @returns {Promise<any>} The promise that resolves with the response data.
 */
const getSinglePackets = async (packetId: any): Promise<any> =>
    APIManager.sendGet(
        `${ManagePacketEnd.GET_PACKET}/${packetId}`,
        true,
        {},
        {},
        axios
    );
/**
 * Sends a request to retrieve packets data using method GET /getPackets.
 * @param {any} data - The request data.
 * @returns {Promise<any>} The promise that resolves with the response data.
 */
const getPacketAuditfile = async (data: any): Promise<any> =>
    APIManager.sendGetWithBody(
        ManagePacketEnd.GET_PACKETS_AUDIT,
        data,
        true,
        axios
    );

/**
 * Sends a request to retrieve packets data using method POST /getPackets.
 * @param {any} data - The request data.
 * @returns {Promise<any>} The promise that resolves with the response data.
 */
const replaceDocument = async (data: ReplaceDocumentRequest): Promise<any> =>
    APIManager.sendPost(
        ManagePacketEnd.REPLACE_DOCUMENT,
        data,
        true,
        {},
        {},
        axios
    );

/**
 * Fetch a request to retrieve category using method GET /getCategory.
 * @param {any} data - The request data.
 * @returns {Promise<any>} The promise that resolves with the response data.
 */
const getCategory = async (data: GetCategoriesRequest): Promise<any> =>
    APIManager.sendGetWithBody(ManagePacketEnd.GET_CATEGORY, data, true, axios);
/**
 * Fetch a request to retrieve SaS Azure Token using method GET /getSastoken.
 * @param {any} data - The request data.
 * @returns {Promise<any>} The promise that resolves with the response data.
 */
const getSasToken = async (data: SaSRequest): Promise<any> =>
    APIManager.sendGetWithBody(ManagePacketEnd.GET_SASTOKEN, data, true, axios);

/**
 * Send a request to update categories using method POST /updateCategory.
 * @param {UpdateCategoryRequest} data - The request data.
 * @returns {Promise<any>} The promise that resolves with the response data.
 */
const updateCategory = async (data: UpdateCategoryRequest): Promise<any> =>
    APIManager.sendPost(
        ManagePacketEnd.UPDATE_CATEGORY,
        data,
        true,
        {},
        {},
        axios
    );
/**
 * Send a request to update categories using method POST /updateCategory.
 * @param {UpdateCategoryRequest} data - The request data.
 * @returns {Promise<any>} The promise that resolves with the response data.
 */
const moveToCategorization = async (data: MoveCategoryRequest): Promise<any> =>
    APIManager.sendPatch(
        ManagePacketEnd.MOVE_CATEGORY,
        data,
        true,
        {},
        {},
        axios
    );
/**
 * Send a request to update categories using method POST /updateCategory.
 * @param {UpdateCategoryRequest} data - The request data.
 * @returns {Promise<any>} The promise that resolves with the response data.
 */
const updateGrouping = async (data: UpdateGroupingRequest): Promise<any> =>
    APIManager.sendPatch(
        ManagePacketEnd.UPDATE_GROUPING,
        data,
        true,
        {},
        {},
        axios
    );
/**
 * Patch a packet for status changed to cm9 using method PATCH /moveToCm9.
 * @param {moveToCM9Request} data - The request data.
 * @returns {Promise<any>} The promise that resolves with the response data.
 */
const moveToCM9 = async (data: moveToCM9Request): Promise<any> =>
    APIManager.sendPatch(
        ManagePacketEnd.MOVE_TO_CM9,
        data,
        true,
        {},
        {},
        axios
    );
/**
 * Send a request for status changed to rework using method POST /sentForRework.
 * @param {SendReworkRequest} data - The request data.
 * @returns {Promise<any>} The promise that resolves with the response data.
 */
const sendToRework = async (data: SendReworkRequest): Promise<any> =>
    APIManager.sendPost(
        ManagePacketEnd.SEND_TO_REWORK,
        data,
        true,
        {},
        {},
        axios
    );

/**
 * Fetch a request to retrieve review packet data using method GET /getReview.
 * @param {GetReviewRequest} data - The request data.
 * @returns {Promise<any>} The promise that resolves with the response data.
 */
const getReview = async (data: GetReviewRequest): Promise<any> =>
    APIManager.sendGetWithBody(ManagePacketEnd.GET_REVIEW, data, true, axios);

/**
 * Send a request to update review packet data using method POST /reviewPacket.
 * @param {GetReviewRequest} data - The request data.
 * @returns {Promise<any>} The promise that resolves with the response data.
 */
const reviewPacket = async (data: ReviewPacketRequest): Promise<any> =>
    APIManager.sendPost(
        ManagePacketEnd.REVIEW_PACKET,
        data,
        true,
        {},
        {},
        axios
    );

/**
 * Patch a packet data using method PATCH /operatorAction.
 * @param {PatchOperatorAction} data - The request data.
 * @returns {Promise<any>} The promise that resolves with the response data.
 */
const patchOperatorAction = async (data: PatchOperatorAction): Promise<any> =>
    APIManager.sendPatch(ManagePacketEnd.OPS_ACTION, data, true, {}, {}, axios);

/**
 * Patch a packet data using method PATCH /operatorAction.
 * @param {PatchOperatorAction} data - The request data.
 * @returns {Promise<any>} The promise that resolves with the response data.
 */
const patchHighlightPacket = async (data: PatchHighlightAction): Promise<any> =>
    APIManager.sendPatch(
        ManagePacketEnd.HIGHLIGHT_ACTION,
        data,
        true,
        {},
        {},
        axios
    );

/**
 * Delete a packet data using method DELETE /packet/{packetId}.
 * @param {PatchOperatorAction} data - The request data.
 * @returns {Promise<any>} The promise that resolves with the response data.
 */
const deletePacket = async (packetId: any): Promise<any> =>
    APIManager.sendDelete(
        `${ManagePacketEnd.DELETE_PACKET}/${packetId}`,
        true,
        {},
        {},
        axios
    );

/**
 * Post a packet to rerun validating.
 * @param {PatchOperatorAction} data - The request data.
 * @returns {Promise<any>} The promise that resolves with the response data.
 */
const rerunValidation = async (data: PostReRunValidation): Promise<any> =>
    APIManager.sendPost(
        ManagePacketEnd.rerun_VALIDATION,
        data,
        true,
        {},
        {},
        axios
    );

/**
 * Post a packet to rerun.
 * @param {PatchOperatorAction} data - The request data.
 * @returns {Promise<any>} The promise that resolves with the response data.
 */
const rerunPacket = async (data: PostReRunValidation): Promise<any> =>
    APIManager.sendPost(
        ManagePacketEnd.rerun_PACKET,
        data,
        true,
        {},
        {},
        axios
    );

/**
 * Post a packet to rerun doc duplication.
 * @param {PatchOperatorAction} data - The request data.
 * @returns {Promise<any>} The promise that resolves with the response data.
 */
const rerunDuplicate = async (data: PostReRunValidation): Promise<any> =>
    APIManager.sendPost(
        ManagePacketEnd.rerun_DUPLICATE,
        data,
        true,
        {},
        {},
        axios
    );

/**
 * Post a packet to rerun Grouping.
 * @param {PatchOperatorAction} data - The request data.
 * @returns {Promise<any>} The promise that resolves with the response data.
 */
const rerunGrouping = async (data: PostReRunValidation): Promise<any> =>
    APIManager.sendPost(
        ManagePacketEnd.rerun_GROUPING,
        data,
        true,
        {},
        {},
        axios
    );

const getAbortProtocol = (): null | AbortController => {
    const proxy = APIManager.getAbortProxy();
    if (typeof proxy === 'object' && proxy !== null) {
        try {
            return proxy.proxy.controller;
        } catch (error) {
            return null;
        }
    }
    return null;
};

const getBoundEventPacketService = (): MessageChannel =>
    APIManager.getBoundEvent();

const resetEventPacketService = (): void => {
    APIManager.setMIAChannel();
};

const getProfileStateTemplateEnabler = (): boolean =>
    store.getState().profileState.userInfo.customDashboardTemplateEnabled;
const getProfileStateGlobalTemplateEnabler = (): boolean =>
    store.getState().profileState.userInfo.globalDashboardTemplateEnabled;
// const getProfileStateGlobalTemplateEnabler = (): boolean => false;
const GetGlobalTemplateCustomToken = (): string =>
    store.getState().profileState.userInfo.globalDashboardTemplateId;
const GetTemplateCustomToken = (): string =>
    store.getState().profileState.userInfo.customDashboardTemplateId;
const GetTemplateDefaultToken = (): string =>
    store.getState().profileState.userInfo.defaultDashboardTemplateId;
const getReinitialization = (): boolean =>
    store.getState().baseAppState.sidebarOptions.dashboard.resetInitialize;
const getCacheTemplateState = (): string =>
    store.getState().baseAppState.sidebarOptions.dashboard.reduxInitValues;
const getBrowserRouter = (): any => store.getState().router;
const isFetchingTemplate = (): any =>
    store.getState().baseAppState.fetchingTemplate;

// To fetch first template

const getProperTemplateId = (): string => {
    if (getProfileStateGlobalTemplateEnabler()) {
        return GetGlobalTemplateCustomToken();
    }
    if (getProfileStateTemplateEnabler()) {
        return GetTemplateCustomToken();
    }
    return GetTemplateDefaultToken();
};

// Function that will be called to refresh authorization
const checkAndParsingTemplate = (params: any): Promise<boolean> =>
    new Promise(async (resolve, reject) => {
        await TemplateService.getTemplate({
            templateId: getProperTemplateId(),
        })
            .then((response: any) => {
                const { query } = response.data.data;

                let resolver = false;
                const paramsObj = params;
                Object.keys(paramsObj).forEach((key) =>
                    paramsObj[key] === undefined ? delete paramsObj[key] : {}
                );
                if (isFetchingTemplate() === false) {
                    store.dispatch(
                        BaseAppActions.setSidebarFetchTemplate(true)
                    );
                    store.dispatch(
                        BaseAppActions.setSidebarDashboardFromInterceptor(
                            query ?? {}
                        )
                    );
                    resolve(true);
                }

                const paramsKey = Object.keys(query);
                if (paramsKey.length !== Object.keys(paramsObj).length) {
                    resolve(false);
                }

                // eslint-disable-next-line no-plusplus
                for (let index = 0; index < paramsKey.length; index++) {
                    const value: any = paramsKey[index];
                    if (
                        TemplateService.getParamsCheckByValue(
                            value,
                            query,
                            params
                        )
                    ) {
                        resolver = true;
                    } else {
                        resolver = false;
                        break;
                    }
                }
                store.dispatch(
                    BaseAppActions.setSidebarDashboardFromInterceptor(
                        query ?? {}
                    )
                );
                resolve(resolver);
            })
            .catch((error) => {
                reject(error);
            });
    });
// Function that will be called to refresh authorization
const checkCacheTemplate = (params: any, query: any): boolean => {
    let resolver = false;
    const paramsObj = params;
    Object.keys(paramsObj).forEach((key) =>
        paramsObj[key] === undefined ? delete paramsObj[key] : {}
    );

    const paramsKey = Object.keys(query);
    if (paramsKey.length !== Object.keys(paramsObj).length) {
        return false;
    }

    // eslint-disable-next-line no-plusplus
    for (let index = 0; index < paramsKey.length; index++) {
        const value: any = paramsKey[index];
        if (TemplateService.getParamsCheckByValue(value, query, params)) {
            resolver = true;
        } else {
            resolver = false;
            break;
        }
    }
    return resolver;
};

axios.interceptors.request.use(async (config: any) => {
    if (config.url === ManagePacketEnd.GET_PACKETS) {
        const router = getBrowserRouter();
        const cacheQuery = getCacheTemplateState();
        if (router.location && router.location.pathname === '/dashboard') {
            if (
                isFetchingTemplate() === true &&
                getReinitialization() === false &&
                checkCacheTemplate(config.params, cacheQuery)
            ) {
                const parsedConfig = config;
                parsedConfig.params = {
                    templateId: getProperTemplateId(),
                };
                return parsedConfig;
            }
            if (
                isFetchingTemplate() === false ||
                getReinitialization() === true
            ) {
                if (
                    getProfileStateGlobalTemplateEnabler() === true &&
                    checkCacheTemplate(config.params, cacheQuery)
                ) {
                    const parsedConfig = config;
                    parsedConfig.params = {
                        templateId: getProperTemplateId(),
                    };
                    return parsedConfig;
                }
                const parsedConfig = await checkAndParsingTemplate(
                    config.params
                )
                    .then((response) => {
                        if (response === true) {
                            const parsingConfig = config;
                            parsingConfig.params = {
                                templateId: getProperTemplateId(),
                            };

                            return parsingConfig;
                        }
                        return config;
                    })
                    .catch((error) => {
                        throw new CancelStatic(error.message);
                    });
                return parsedConfig;
            }
        }
    }
    if (config.url === RestEnds.LOGIN) {
        store.dispatch(BaseAppActions.setSidebarFetchTemplate(false));
    }
    return config;
});

export const ManagePacketService = {
    rerunPacket,
    rerunValidation,
    rerunDuplicate,
    deletePacket,
    getBoundEventPacketService,
    resetEventPacketService,
    patchHighlightPacket,
    getPacketAuditfile,
    patchOperatorAction,
    getPackets,
    getCategory,
    getSasToken,
    updateCategory,
    moveToCategorization,
    updateGrouping,
    sendToRework,
    getReview,
    getSinglePackets,
    replaceDocument,
    moveToCM9,
    reviewPacket,
    getAbortProtocol,
    checkCacheTemplate,
    getReportVertices,
    reviewReport,
    rerunGrouping,
};
